import * as React from 'react';
import { useEffect } from 'react';

import { AnalyticsStore } from 'bernie-core';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { trackAnalytics } from 'utility';
import { useStores } from 'utility/hooks';
import { AnchorTracked } from 'components/shared/tracked';
import { FlightsPhrasePartStyle } from '../../__generated__/api/types';
import { AnalyticsType, PhrasePartType, PhrasePartStyle } from 'types/shared';

interface PhraseProps {
  completeText: string;
  items?: PhrasePartType[];
}

interface PhrasePartProps {
  __typename?: string;
  accessibility?: string;
  analytics?: AnalyticsType;
  displayAnalytics?: AnalyticsType;
  icon?: string;
  link?: string;
  styles: string[];
  styleIndex: number;
  text: string;
  analyticStore: AnalyticsStore;
}

export const Phrase = (props: PhraseProps) => {
  const { completeText, items } = props;
  const { analytics } = useStores();
  if (items && items.length) {
    return (
      <>
        {items.map((item, index) => {
          return <PhrasePart key={`phrase-part-${index}`} {...item} styleIndex={0} analyticStore={analytics} />;
        })}
      </>
    );
  }

  return <>{completeText}</>;
};

export const PhrasePart = (props: PhrasePartProps) => {
  const { __typename, styles, text, styleIndex, analyticStore, displayAnalytics } = props;
  const style = styles[styleIndex];
  const recursivelyCallPhrasePart = styleIndex < styles.length - 1;
  const PhrasePartTag =
    style === FlightsPhrasePartStyle.STANDARD
      ? React.Fragment
      : PhrasePartStyle[style] || PhrasePartStyle[FlightsPhrasePartStyle.STANDARD];

  useEffect(() => {
    if (__typename === 'FlightsPhraseLinkNode') {
      trackAnalytics(displayAnalytics, analyticStore);
    }
  }, [__typename, displayAnalytics, analyticStore]);

  if (recursivelyCallPhrasePart) {
    return (
      <PhrasePartTag>
        <PhrasePart {...props} styleIndex={styleIndex + 1} />
      </PhrasePartTag>
    );
  }

  if (__typename === 'FlightsPhraseLinkNode') {
    const { analytics, link, accessibility, icon } = props;
    const linkProps = {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: link
    };

    return (
      <PhrasePartTag>
        <AnchorTracked {...analytics} {...linkProps} aria-label={accessibility}>
          {text}
          {icon && (
            <UitkIcon name={icon} size={UitkIconSize.EXTRA_SMALL} className="all-l-margin-one all-b-margin-one" />
          )}
        </AnchorTracked>
      </PhrasePartTag>
    );
  }

  return <PhrasePartTag>{text}</PhrasePartTag>;
};

export default Phrase;
